<template v-if="emails_is_signed_in">
        <div class="eml-emails-menu-ctn">
<!--            <o-menu-item  v-if="!emails_is_signed_in">-->
<!--                <router-link :to="{ name: 'emails' }">Inbox</router-link>-->
<!--            </o-menu-item >-->
                <div class="eml-menu-item" v-for="(item, key) in labels" :key="key">
                    <router-link :class="{'is-active': isActive(item), 'eml-item-ctn': true}" @click.native="handleEmailLabelMenu(item, $event)" :to="{ name: 'emails', params: { label: item.id } }" active-class="activated" style="display: flex; align-items: center; justify-content: space-evenly">
                        <img class="eml-menu-icon" :src="item.iconUrl" :alt="item.name" style="padding: 0 5px"/>
                        <div class="eml-menu-item-txt-ctn" style="padding: 0 5px; display: flex; justify-content: space-evenly"><span class="eml-menu-item-text">{{ item.name }}</span>
                        <span v-if="shouldShowBadge(item)" style="padding: 0 5px" class="badge is-pulled-right">
                            {{getBadge(item)}}
                        </span>
                        </div>
                    </router-link>
                </div>
                <user-labels-menu :labels="user_labels" />
        </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { getLabelInfo, listLabels } from "./gmail_api"
    import UserLabelsMenu from './UserLabelsMenu.vue'

    export default {
        components: {
                UserLabelsMenu,
        },
        computed: {
            ...mapGetters([
                'emails_is_signed_in',
                'emails_label',
                'emails_labels',
            ]),
            is_menu_active() {
                return /^emails(?:\.[a-z\.]*)?$/g.test(this.$route.name)
            },
            labels() {
                return Object.keys(this.emails_labels).map(k => this.emails_labels[k]).filter(i => i.type !== 'user')
            },
            user_labels() {
                return Object.keys(this.emails_labels).map(k => this.emails_labels[k]).filter(i => i.type === 'user')
            },
        },
        data () {
            return {
            }
        },
        methods: {
            ...mapActions(['closeSidebar', 'emails_set_label', 'emails_set_labels']),
            getBadge(item) {
                return (item.id === 'UNREAD' && this.emails_labels.INBOX.threadsUnread) || (item.id === 'DRAFT' && item.threadsTotal) || item.threadsUnread || '0'
            },
            handleEmailLabelMenu(item, e) {
                this.closeSidebar(e)
            },
            handleMenuToggle(isActive) {
                !this.is_menu_active && isActive && this.$router.push({ name: 'emails', params: { label: this.emails_label } })
            },
            init() {
                if(!this.emails_is_signed_in) {
                    return
                }
                listLabels().then((labels_ = []) => {
                    const labels = { ...this.emails_labels }
                    labels_.filter(i => i.type === 'user').forEach(i => {
                        labels[i.id] = i
                        labels[i.id].iconUrl = 'https://www.gstatic.com/images/icons/material/system_gm_filled/1x/label_gm_grey_24dp.png'
                    })
                    this.set_labels_info(labels)
                })
            },
            isActive(item) {
                return this.emails_label.split(',')[0] === item.id
            },
            set_labels_info(labels = this.emails_labels) {
                const promises = Object.keys(labels).map(k => labels[k]).filter(i => (['DRAFT', 'INBOX'].includes(i.id) || i.type === 'user') ).map(i => getLabelInfo(i.id).then(label_info => {
                        labels[label_info.id] = labels[label_info.id] || label_info
                        labels[label_info.id].messagesTotal = label_info.messagesTotal
                        labels[label_info.id].messagesUnread = label_info.messagesUnread
                        labels[label_info.id].threadsTotal = label_info.threadsTotal
                        labels[label_info.id].threadsUnread = label_info.threadsUnread
                        return label_info
                }))
                Promise.allSettled(promises).then((result) => {
                    this.emails_set_labels(labels)
                })
            },
            shouldShowBadge(item) {
                return ['DRAFT', 'UNREAD'].includes(item.id) || item.type === 'user'
            },
        },
        mounted() {
            this.init()
        },
        watch: {
            emails_is_signed_in(value) {
                if(value) {
                    this.init()
                }
            },
            $route(to, from) {
                if (this.$refs.menu_dropdown) {
                    this.$refs.menu_dropdown.isActive = /^emails(?:\.[a-z\.]*)?$/g.test(to.name)
                }
            },
        },
    }
</script>
<style lang="sass">
.sidebar>.menu>.b-menu-list>.menu-list>li.eml-emails-menu.eml-menu-active>a
  padding: 1.063rem 1rem
.eml-emails-menu
  >a
    padding: 1.063rem 1rem
  .eml-emails-menu-ctn
    padding: 8px 0
    .eml-menu-item
      margin-top: 2px
      .eml-item-ctn
        color: rgba(255, 255, 255, 0.5)
        align-items: center
        border-radius: 0 16px 16px 0
        display: flex
        height: 32px
        padding: 1rem 1rem !important

        transition: margin .15s cubic-bezier(0.4,0.0,0.2,1),padding .15s cubic-bezier(0.4,0.0,0.2,1)
        &.is-active
          background-color: #019ae0
          color: white
          .eml-menu-icon
            opacity: 1
          .eml-menu-item-text, .badge
            padding-top: 2px
        .eml-menu-icon
          align-items: center
          display: flex
          flex-shrink: 0
          height: 20px
          justify-content: flex-start
          margin-right: 6px
          opacity: 0.54
          width: 20px
          &:before
            content: ''
            background-image: var(--bg-image)
            background-position: center
            background-repeat: no-repeat
            background-size: 20px
            display: block
            height: 20px
            width: 20px
        .eml-menu-item-txt-ctn
          line-height: 20px
          overflow: hidden
          padding-right: 5px
          text-overflow: ellipsis
          white-space: nowrap
          width: 100%
          .eml-menu-item-text
            display: inline-block
            max-width: 75%
            overflow: hidden
            padding-left: 6px
            text-overflow: ellipsis
          .badge
            display: block
            font-size: .75rem
            font-weight: 700
            letter-spacing: .3px
            line-height: 21px
            text-shadow: none
</style>